import { useState } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import TendersHero from "./components/TendersHero";
import TendersList from "./components/TendersList";
import TenderSupportForm from "./components/TenderSupportForm";

export default function TendersPage() {
  const [prefilledReference, setPrefilledReference] = useState("");

  return (
    <main>
      <Helmet>
        <title>Tenders in East Africa | Government & Private Sector Opportunities | AIP</title>
        <meta name="description" content="Browse active tenders across East Africa. AIP connects businesses with government and private sector tender opportunities in Rwanda, Kenya, Uganda, Tanzania, and more." />
        <meta name="keywords" content="tenders East Africa, government tenders Rwanda, government tenders Kenya, private sector tenders Africa, procurement opportunities East Africa, tender support Africa" />
        <link rel="canonical" href="https://africainvestmentportal.com/tenders" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Tenders in East Africa | Government & Private Sector Opportunities" />
        <meta property="og:description" content="Browse active tenders across East Africa — Rwanda, Kenya, Uganda, Tanzania, and more." />
        <meta property="og:url" content="https://africainvestmentportal.com/tenders" />
        <meta property="og:image" content="https://africainvestmentportal.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tenders in East Africa | Government & Private Sector Opportunities" />
        <meta name="twitter:description" content="Browse active tenders across East Africa — Rwanda, Kenya, Uganda, Tanzania, and more." />
      </Helmet>
      <Navbar />
      <TendersHero />
      <TendersList onRequestSupport={(ref) => setPrefilledReference(ref)} />
      <TenderSupportForm prefilledReference={prefilledReference} />
      <Footer />
    </main>
  );
}
